/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export * from './auth.module';
export * from './components';



// WEBPACK FOOTER //
// ./src/app/auth/index.ts